
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";

import Layout from "~/components/Layout";
import ScrollToTop from "~/components/ScrollToTop";

import './index.less';

const container = createRoot(document.getElementById("app") || document.body);

container.render(<Router>
	<ScrollToTop />
	<Layout />
</Router>);
